import { request } from "@/api/request";


export async function apiLogin(args) {
    const rv = await request({
        url: "/api/login",
        method: "post",
        data: args
    });
    return rv;
}

export async function apiLogout(args) {
    const rv = await request({
        url: "/api/logout",
        method: "post",
        data: args
    });
    return rv;
}

export async function apiProfile() {
    const rv = await request({
        url: "/api/profile",
        method: "get"
    });
    return rv;
}

export async function apiConfirm(args) {
    const rv = await request({
        url: "/api/confirm",
        method: "post",
        data: args
    });
    return rv;
}

export async function apiLostPassword(args) {
    const rv = await request({
        url: "/api/lost-password",
        method: "post",
        data: args
    });
    return rv;
}

export async function apiResetPassword(args) {
    const rv = await request({
        url: "/api/reset-password",
        method: "post",
        data: args
    });
    return rv;
}

export async function apiUsers() {
    const rv = await request({
        url: "/api/users",
        method: "get"
    });
    return rv;
}

export async function apiUpdateUser(id, args) {
    const rv = await request({
        url: "/api/users/" + id,
        method: "put",
        data: args
    });
    return rv;
}

export async function apiDeleteUser(id) {
    const rv = await request({
        url: "/api/users/" + id,
        method: "delete",
    });
    return rv;
}

export async function apiCreateUser(userData) {
    const rv = await request({
        url: 'api/users',
        method: 'post',
        data: userData
    });

    return rv;
}

export async function getBirthdays() {
    const rv = await request({
        url: 'api/law-firm/birthdays',
        method: 'get'
    });

    return rv;
}

export async function getTeamleaders() {
    const rv = await request({
        url: '/api/teamleaders',
        method: 'get'
    });

    return rv;
}

export async function getEmployees() {
    const rv = await request({
        url: '/api/employees',
        method: 'get'
    });

    return rv;
}

export async function archiveUser(id, requestData) {
    const rv = await request({
        url: '/api/users/' + id + '/archive',
        method: 'post',
        data: requestData
    });

    return rv;
}